import { useIsFetching } from "@tanstack/react-query";

export const useAnalyticsAudienceFetching = () => {
  return useIsFetching({
    predicate: (query) => {
      // Check if the query key contains 'variation_timeseries_cumulative'
      return query.queryKey.some(
        (key) =>
          typeof key === "object" &&
          JSON.stringify(key).includes("variation_audience")
      );
    },
  });
};
